import * as React from 'react';
import { useLearningPathway } from './learning-pathway/hook';
import Header, { HeaderPreloader } from './learning-pathway/partials/Header';
import Layout, { LayoutFallback, LayoutPreloader } from './learning-pathway/partials/Layout';
import { useZustand } from "use-zustand";
import { pathwayStore } from "./learning-pathway/store";
import { Config } from "./learning-pathway/helper";
import Modal from './learning-pathway/partials/Modal';

export default function (props) {
  const {
    description
  } = useLearningPathway(props.pathwayID);

  const {
    componentState,
    errors = [],
    setErrors,
  } = useZustand(pathwayStore, (state) => ({
    componentState: state.componentState,
    errors: state.errors,
    setErrors: state.setErrors,
  }));

  const closeModalCallback = () => {
    setErrors([]);
  }

  if (Config.State.initial === componentState) {
    return (
      <div className='nv-learning-pathway'>
        <HeaderPreloader title={props.title} estimatedTime={props.estimated_time}/>
        <LayoutPreloader/>
      </div>
    );
  }

  if (Config.State.failed === componentState) {
    return (
      <div className='nv-learning-pathway'>
        <HeaderPreloader title={props.title} estimatedTime={props.estimated_time}/>
        <LayoutFallback/>
      </div>
    );
  }

  return (
    <div className='nv-learning-pathway'>
      <Header title={props.title} text={description} estimatedTime={props.estimated_time}/>
      <Layout/>
      <Modal
        isOpen={errors?.length > 0}
        text={errors.join('; ')}
        title={Config.I18n.Errors.ModalTitle}
        closeModal={closeModalCallback}
      />
    </div>
  );
}
